module.exports = __webpack_public_path__ + "static/017-7f24e979f2fd9a763c85c3ab17a08d29.jpg";